Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfoTemplate = {
  createFormTemplate: function () {
    return {
      'items': [
        {
          'items': [
            {
              'tag': 'ul',
              'items': [
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Driver'),
                      'attributes': {
                        'href': '#taskManager-driver',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Equipment'),
                      'attributes': {
                        'href': '#taskManager-equipment',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Route'),
                      'attributes': {
                        'href': '#taskManager-route',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Location'),
                      'attributes': {
                        'href': '#taskManager-location',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Event'),
                      'attributes': {
                        'href': '#taskManager-event',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Task'),
                      'attributes': {
                        'href': '#taskManager-task',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Survey'),
                      'attributes': {
                        'href': '#taskManager-survey',
                      },
                    },
                  ],
                },
                {
                  'tag': 'li',
                  'items': [
                    {
                      'tag': 'a',
                      'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Order'),
                      'attributes': {
                        'href': '#taskManager-order',
                      },
                    },
                  ],
                },
              ],
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'items': [
                        {
                          'attributes': {
                            'id': 'tabDriverLookupDriver',
                            'class': 'control-group lookupList',
                            'lookup_entity': 'Driver',
                            'lookup_entity_column': 'key',
                            'name': 'driver',
                            'label': 'TaskManager.Tab.Driver',
                          },
                        },
                      ],
                      'attributes': {
                        'class': 'form-horizontal',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'span4',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-driver',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'attributes': {
                        'id': 'tabEquipmentLookupEquipment',
                        'class': 'control-group lookupList',
                        'lookup_entity': 'Equipment',
                        'lookup_entity_column': 'key',
                        'name': 'equipment',
                        'label': Monet.I18n.getResourcesByKey('TaskManager.Tab.Event.Equipment'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'form-horizontal',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-equipment',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'attributes': {
                        'class': 'monetInlineAlerContainer',
                      },
                    },
                    {
                      'items': [
                        {
                          'attributes': {
                            'id': 'tabRouteLookupOrganization',
                            'class': 'control-group lookup',
                            'lookup_entity': 'Organization',
                            'lookup_entity_column': 'description',
                            'name': 'organization',
                            'label': 'TaskManager.Tab.Route.Organization',
                          },
                        },
                        {
                          'items': [
                            {
                              'tag': 'label',
                              'items': [
                                {
                                  'tag': 'span',
                                  'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Route.Route'),
                                },
                              ],
                              'attributes': {
                                'for': 'key',
                                'name': 'key',
                              },
                            },
                            {
                              'tag': 'input',
                              'attributes': {
                                'name': 'key',
                                'class': 'mandatory',
                                'id': 'key',
                                'type': 'text',
                              },
                            },
                          ],
                          'attributes': {
                            'class': 'control-group',
                          },
                        },
                        {
                          'items': [
                            {
                              'tag': 'label',
                              'items': [
                                {
                                  'tag': 'span',
                                  'html': Monet.I18n.getResourcesByKey('TaskManager.Tab.Route.Date'),
                                },
                              ],
                              'attributes': {
                                'for': 'routeDate',
                              },
                            },
                            {
                              'tag': 'input',
                              'attributes': {
                                'name': 'routeDate',
                                'id': 'routeDate',
                                'class': 'dateField',
                                'type': 'text',
                              },
                            },
                          ],
                          'attributes': {
                            'class': 'control-group',
                          },
                        },
                        {
                          'items': [
                            {
                              'tag': 'input',
                              'attributes': {
                                'class': 'btn i18nResource',
                                'name': 'transferStopBtnSearchRoute',
                                'id': 'transferStopBtnSearchRoute',
                                'value': Monet.I18n.getResourcesByKey('TaskManager.Tab.Route.Search'),
                                'type': 'button',
                              },
                            },
                          ],
                          'attributes': {
                            'class': 'taskManager-route___filter-btn',
                          },
                        },
                        {
                          'attributes': {
                            'class': 'GreenmileTaskRouteList',
                          },
                        },
                      ],
                      'attributes': {
                        'class': 'taskManager-route___inputs',
                      },
                    },
                    {
                      'attributes': {
                        'id': 'route_list',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'row',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-route',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'attributes': {
                        'id': 'tabLocationLookupLocation',
                        'class': 'control-group lookupList',
                        'lookup_entity': 'Location',
                        'lookup_entity_column': 'key',
                        'name': 'location',
                        'label': 'TaskManager.Tab.Location',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'form-horizontal',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-location',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'attributes': {
                        'class': 'monetInlineAlerContainer',
                      },
                    },
                    {
                      'attributes': {
                        'id': 'tabEventLookupEquipment',
                        'class': 'control-group lookup',
                        'lookup_entity': 'Equipment',
                        'lookup_entity_column': 'description',
                        'name': 'tabEventEquipment',
                        'label': 'TaskManager.Tab.Event.Equipment',
                      },
                    },
                    {
                      'attributes': {
                        'id': 'tabEventLookupRoute',
                        'class': 'control-group lookup',
                        'lookup_entity': 'Route',
                        'lookup_entity_column': 'description',
                        'name': 'eventRoute',
                        'label': 'TaskManager.Tab.Event.Route',
                      },
                    },
                    {
                      'attributes': {
                        'id': 'tabEventLookupStop',
                        'class': 'control-group lookup',
                        'lookup_entity': 'StopLookup',
                        'lookup_entity_column': 'key',
                        'name': 'stop',
                        'label': 'TaskManager.Tab.Event.Stop',
                      },
                    },
                    {
                      'attributes': {
                        'id': 'tabEventLookupEventType',
                        'class': 'control-group lookup',
                        'lookup_entity': 'Event',
                        'lookup_entity_column': 'description',
                        'name': 'event',
                        'label': 'TaskManager.Tab.Event.EventType',
                      },
                    },
                    {
                      'items': [
                        {
                          'tag': 'input',
                          'attributes': {
                            'type': 'button',
                            'class': 'btn i18nResource',
                            'name': 'filter',
                            'id': 'btnFilterEventos',
                            'value': Monet.I18n.getResourcesByKey('default.button.filter'),
                          },
                        },
                        {
                          'tag': 'input',
                          'attributes': {
                            'type': 'button',
                            'class': 'btn i18nResource',
                            'name': 'filter',
                            'id': 'btnFilterClear',
                            'value': Monet.I18n.getResourcesByKey('default.button.clear'),
                          },
                        },
                      ],
                      'attributes': {
                        'class': 'filter-group standard-form-buttons',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'row',
                  },
                },
                {
                  'items': [
                    {
                      'attributes': {
                        'class': 'taskEventsFiltered',
                      },
                    },
                    {
                      'attributes': {
                        'class': 'taskEventsSelected',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'eventlist-group',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-event',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'attributes': {
                        'id': 'tabTaskLookupTask',
                        'class': 'control-group lookupList',
                        'lookup_entity': 'Task',
                        'lookup_entity_column': 'title',
                        'name': 'task',
                        'label': 'TaskManager.Tab.Event.EventType',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'form-horizontal',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-task',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'items': [
                        {
                          'attributes': {
                            'id': 'tabSurveyLookupSurvey',
                            'class': 'control-group lookupList',
                            'lookup_entity': 'Survey',
                            'lookup_entity_column': 'title',
                            'name': 'survey',
                            'label': 'TaskManager.Tab.Survey',
                          },
                        },
                      ],
                      'attributes': {
                        'class': 'form-horizontal',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'span4',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'equipmentTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'equipmentTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-survey',
              },
            },
            {
              'items': [
                {
                  'items': [
                    {
                      'items': [
                        {
                          'attributes': {
                            'id': 'tabSurveyLookupOrder',
                            'class': 'control-group lookupList',
                            'lookup_entity': 'Order',
                            'lookup_entity_column': 'number',
                            'name': 'order',
                            'label': 'TaskManager.Tab.Order',
                          },
                        },
                      ],
                      'attributes': {
                        'class': 'form-horizontal',
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'span4',
                  },
                },
                {
                  'items': [
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupSave',
                        'id': 'orderTaskManagerPopupSave',
                        'value': Monet.I18n.getResourcesByKey('default.button.save'),
                        'style': 'float:right;',
                      },
                    },
                    {
                      'tag': 'input',
                      'attributes': {
                        'type': 'button',
                        'class': 'btn i18nResource',
                        'name': 'taskManagerPopupCancel',
                        'id': 'orderTaskManagerPopupCancel',
                        'value': Monet.I18n.getResourcesByKey('default.button.cancel'),
                      },
                    },
                  ],
                  'attributes': {
                    'class': 'taskManagerButtonBox standard-form-buttons',
                  },
                },
              ],
              'attributes': {
                'id': 'taskManager-order',
              },
            }
          ],
          'attributes': {
            'id': 'taskManagerTabs',
          },
        },
      ],
    };
  },
};
